import { useEsAiUsage } from './EsAi';
import { esFormatCurrency } from './EsIntl';
import { useEsStrings } from './EsStrings';

/**
 * The AI meter (es-ai-service.md §3): "$0.35 of $0.50 this month", on the account page and in the
 * header of every AI panel. At a table it reads the GM's pot and says whose; an administrator has
 * no pot and reads the site's spend against the ceiling instead. Nothing while the usage loads or
 * when esback refuses it, which is how the meter stays hidden with switchEsAi off.
 */
export default function EsAiMeter( { campaignId, className, 'data-testid': dataTestId = 'es-ai-meter' } ) {
    const t = useEsStrings();
    const usage = useEsAiUsage( campaignId );
    if ( !usage ) return null;

    const spent = esFormatCurrency( usage.spentCents ?? 0 );
    const pot = usage.potCents == null ? null : esFormatCurrency( usage.potCents );
    const line = usage.site ? t( 'ai-meter-site', '{spent} of the {pot} site ceiling this month', { spent, pot } )
        : pot == null ? t( 'ai-meter-uncapped', '{spent} this month', { spent } )
            : t( 'ai-meter', '{spent} of {pot} this month', { spent, pot } );

    return (
        <p data-testid={ dataTestId } className={ className ?? 'text-xs text-aside' }
           data-spent={ usage.spentCents ?? 0 } data-pot={ usage.potCents ?? '' }>
            <span data-testid={ dataTestId + '-line' }>{ line }</span>
            { usage.chargedTo &&
                <span data-testid={ dataTestId + '-charged-to' } className="ml-2">
                    { t( 'ai-meter-charged-to', 'From {name}\'s table allowance', { name: usage.chargedTo } ) }
                </span> }
        </p>
    );
}
